module.exports = __webpack_public_path__ + "img/product.b6dee2be.jpg";